module.exports = __webpack_public_path__ + "img/left.990765ce.png";